import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { User } from '../../lib/classes/user';
import { Global } from '../../lib/classes/global';
import { UserProfile } from '../../lib/classes/userProfile';

import {
  FacebookService,
  UnitService,
  UserService,
  Utils,
} from '../../lib/services';
import { ValidationService } from '../../lib/services/validationService';

import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs';
import { Unit } from '../../settings-module/models/unit';

@Component({
  selector: 'mj-invite',
  templateUrl: './invite.component.html',
  styleUrls: ['./invite.component.scss'],
})
export class InviteComponent implements OnInit, OnDestroy, AfterViewChecked {
  public newUser: User = <User>{};
  public unit: Unit = <Unit>{};

  // for existing user
  public password: string;

  public serverErrors: {};
  public fg: any;
  public fg_has_user: any;
  public baseUrl: string;
  public show: {};
  public invalid: boolean;

  // Global
  public $g: Global = new Global();

  private firstNameSubscription$: Subscription;
  private lastNameSubscription$: Subscription;
  private passwordSubscription$: Subscription;

  constructor(
    private _userService: UserService,
    private _companyService: UnitService,
    private _route: ActivatedRoute,
    private _formBuilder: FormBuilder,
    public $u: Utils,
    private _translate: TranslateService,
    private _facebookService: FacebookService,
    public cdRef: ChangeDetectorRef,
    private _router: Router
  ) {}

  public ngOnInit() {
    this.serverErrors = {};
    this.fg = this._formBuilder.group(
      {
        first_name: ['', Validators.required],
        last_name: ['', Validators.required],
        password: [
          '',
          Validators.compose([
            Validators.required,
            ValidationService.passwordValidator,
          ]),
        ],
        passwordCheck: [
          '',
          Validators.compose([
            Validators.required,
            ValidationService.passwordValidator,
          ]),
        ],
      },
      {
        validator: ValidationService.matchingPasswords(
          'password',
          'passwordCheck'
        ),
      }
    );

    this.firstNameSubscription$ = this.fg
      .get('first_name')
      .valueChanges.subscribe(val => {
        this.newUser.first_name = val;
      });
    this.lastNameSubscription$ = this.fg
      .get('last_name')
      .valueChanges.subscribe(val => {
        this.newUser.last_name = val;
      });
    this.passwordSubscription$ = this.fg
      .get('password')
      .valueChanges.subscribe(val => {
        this.newUser.password = val;
      });

    this.invalid = false;

    this.show = {
      regUser: true,
      alert: false,
      invalidEmail: false,
    };

    this.baseUrl = environment.baseURL;

    this._facebookService.trackFacebookAnalyticsEvent(
      'invite_opened_mail_link'
    );

    this._route.queryParams.subscribe(params => {
      const unit_id = params['unit_id'];
      const unit_name = params['unit_name'];
      const username = params['username'];

      if (unit_id && unit_name && username) {
        this.newUser.username = username;
        this.unit.id = unit_id;
        // HACK - angular router translates spaces to + signs
        const re = /\+/g;
        this.unit.name = unit_name.replace(re, ' ');
      } else {
        this._router.navigate(['login']);
      }
    });
  }

  public ngOnDestroy() {
    this.firstNameSubscription$.unsubscribe();
    this.lastNameSubscription$.unsubscribe();
    this.passwordSubscription$.unsubscribe();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  // Function used to employer
  public registerEmployer() {
    if (this.fg.valid) {
      const unit_id = this.unit.id;
      this.serverErrors = {};

      this.newUser.user_profile = <UserProfile>{};

      // Regisers user with filled in credentials
      this._userService.register(this.newUser).subscribe(
        regUser => {
          // When created, loggs in
          this._userService
            .login(this.newUser.username, this.newUser.password)
            .subscribe(token => {
              // When logged in, creates employment
              this._companyService
                .createEmploymentForInvite(unit_id, 'Employee', regUser)
                .subscribe(
                  res => {
                    this._facebookService.trackFacebookAnalyticsEvent(
                      'invite_created_employment'
                    );

                    // Navigates the user to the dashboard
                    localStorage.setItem('unit_id', '' + this.unit.id);
                    localStorage.setItem('unit_name', this.unit.name);
                    this._router.navigate(['dashboard', 'overview']);
                  },
                  error => {
                    this._translate
                      .get([
                        'invite_register_dialog_err_not_found_title',
                        'invite_register_dialog_err_not_found_desc',
                        'invite_register_dialog_err_not_found_btn_close',
                      ])
                      .subscribe(errorStrings => {
                        this.$u.alert({
                          type: 'info',
                          title:
                            errorStrings[
                              'invite_register_dialog_err_not_found_title'
                            ],
                          text:
                            errorStrings[
                              'invite_register_dialog_err_not_found_desc'
                            ],
                          acceptText:
                            errorStrings[
                              'invite_register_dialog_err_not_found_btn_close'
                            ],
                        });
                      });
                  }
                );
            });
        },
        error => {
          if (error.status === 400) {
            this._router.navigate(['login']);
          }
          this.serverErrors = error;
        }
      );
    } else {
      this.invalid = true;
    }
  }

  public toggle(key) {
    this.show[key] = !this.show[key];
  }
}
